import { FC, useState } from 'react'
import { Table, Toolbar, BreadcrumHeader } from 'shared'
import { useTableHandlers } from 'hooks/useTableHandlers'
import { BreadcrumbItemType } from 'shared/molecules/Breadcrum/Breadcrum'
import { DateTimeCell, StatusCell } from 'shared/molecules/table/cells'
import CreateRule from '../createEditRule/CreateRule'
import './rules.scss'
import { useGetRuleQuery } from '../RuleApiSlice'
import { Rule, RuleListRequest } from '../types'

const { Column, HeaderCell, Cell, ActionCell } = Table

const Rules: FC = () => {
  const [addRuleModal, setAddRuleModal] = useState(false)
  const [isEditMode, setIsEditMode] = useState<boolean>(false)
  const [selectRowRule, setSelectRowRule] = useState<Rule | null>(null)
  const { requestBody, onPageChange } = useTableHandlers<Rule, RuleListRequest>(
    {
      page: { size: 10, number: 0 }
    }
  )
  const { data: RuleData, isLoading } = useGetRuleQuery(requestBody)
  const handleTabChange = () => {}

  const handleActionEdit = (rowData: Rule) => {
    setAddRuleModal(true)
    setSelectRowRule(rowData)
  }

  const handleAction = (eventKey: string | undefined, rowData: Rule) => {
    switch (eventKey) {
      case '2':
        setIsEditMode(true)
        handleActionEdit(rowData)
        break
      default:
        break
    }
  }
  const COLUMNS = [
    { key: 'ruleName', label: 'Name' },
    { key: 'fieldPath', label: 'FieldPath' },
    { key: 'salesforceFieldPath', label: 'SalesforceFieldPath' },
    { key: 'active', label: 'active' }
  ]

  const options = [
    {
      label: 'All',
      value: 'All',
      onClick: () => handleTabChange()
    }
  ]

  const total = RuleData?.totalElements ?? 0
  const breadcrumbItems: BreadcrumbItemType[] = [
    {
      label: 'Setting',
      path: '/client',
      isActive: true
    },
    {
      label: 'Rule',
      path: '/client',
      isActive: true
    }
  ]
  const handleClose = () => {
    setAddRuleModal(false)
    setIsEditMode(false)
    setSelectRowRule(null)
  }
  return (
    <div className="list">
      <BreadcrumHeader items={breadcrumbItems} />
      <Toolbar
        options={options}
        total={total}
        onButtonClick={() => setAddRuleModal(true)}
        buttonName="Add Rule"
      />
      <div className="list__main-container">
        <Table
          data={RuleData?.content ?? []}
          loading={isLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={10}
          onPageChange={onPageChange}
        >
          {COLUMNS.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                {key === 'active' ? (
                  <StatusCell
                    dataKey={key}
                    posDataLabel="Active"
                    negDataLabel="Inactive"
                  />
                ) : (
                  <Cell dataKey={key} tooltip />
                )}
              </Column>
            )
          })}

          <Column flexGrow={1} align="center">
            <HeaderCell>CreatedAt</HeaderCell>
            <DateTimeCell dataKey="createdAt" format="dd/MMM/yy, h:mm a" />
          </Column>

          <Column align="center" key="action" sortable>
            <HeaderCell>Action</HeaderCell>

            <ActionCell
              style={{ paddingLeft: '22%' }}
              tooltip
              dataKey="action"
              onAction={handleAction}
              actionOptions={['Edit']}
            />
          </Column>
        </Table>
      </div>
      <CreateRule
        open={addRuleModal}
        onClose={handleClose}
        isEditMode={isEditMode}
        rule={selectRowRule}
      />
    </div>
  )
}
export default Rules
